/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/button-has-type */
/* eslint-disable no-unused-vars */
/* eslint-disable import/no-cycle */
/* eslint-disable no-param-reassign */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useRef, useEffect } from 'react';
import { AIAssistViewComponent } from '@syncfusion/ej2-react-interactive-chat';
import '../pages/Zackat.css'; // Make sure to import your CSS file

const UserFAQ = ({ dt }) => {
  const usr = JSON.parse(localStorage.getItem('user'));
  const { REACT_APP_API_ENDPOINT } = process.env;
  const assistInstance = useRef(null);
  const [prompt, setPrompt] = useState('');
  const [airesponse, setAIResponse] = useState('');

  const promptSuggestions = [
    'What is the ZackatLabs App?',
    'What are the features of the ZackatLabs App?',
    'What is the diference between an Associate and a Manager?',
  ];

  const onPromptRequest = async (args) => {
    // Access the user's prompt from args.promptText
    if (!args || !args.prompt || args.prompt === '') {
      assistInstance.current.addPromptResponse('Please enter a prompt and try again.');
      return;
    }
    const userPrompt = args.prompt;

    try {
      // Replace with your actual backend API endpoint
      const uri = `${REACT_APP_API_ENDPOINT}/kb`;
      const data = { question: userPrompt, kbid: dt };
      const response = await fetch(uri, {
        method: 'PUT', // Or 'GET', depending on your backend
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const mydata = await response.json();
      // Assuming your backend returns a JSON object with a 'response' field
      const backendResponse = mydata.answer;
      setAIResponse(backendResponse);
      // Add the backend's response to the AIAssistView
      assistInstance.current.addPromptResponse(backendResponse);
    } catch (error) {
      console.error('Error fetching data:', error);
      // Handle the error by adding an error message to the UI
      assistInstance.current.addPromptResponse('Sorry, something went wrong. Please try again.');
    }
  };

  useEffect(() => {
    const defaultResponse = 'For real-time prompt processing, connect the AI AssistView control to your preferred AI service, such as OpenAI or Azure Cognitive Services. Ensure you obtain the necessary API credentials to authenticate and enable seamless integration.';

    const fetchFaq = async () => {
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const uri = `${REACT_APP_API_ENDPOINT}/faq?${query}`;
      const data = { question: prompt };
      try {
        const myfaq = await (
          await fetch(uri, {
            method: 'PUT',
            body: JSON.stringify(data),
            headers: {
              'Content-Type': 'application/json',
              Authorization: `JWTToken ${usr.token}`,
            },
          })).json();
        if (myfaq) {
          if (myfaq.answer) {
            assistInstance.current.addPromptResponse(myfaq.answer);
          } else {
            assistInstance.current.addPromptResponse(defaultResponse);
          }
        }
      } catch (error) {
        console.error('Fetch error:', error.message);
      }
    };
    if (prompt !== '') {
      fetchFaq();
    }
  }, [prompt]);

  const bannerTemplate = `<div class="banner-content">
    <div class="e-icons e-assistview-icon"></div>
        <h3>AI Assistance</h3>
        <i>To get started, provide input or choose a suggestion.</i>
    </div>`;
  // Handler for the "Copy" button click
  const handleCopy = (response) => {
    navigator.clipboard.writeText(response);
    console.log('copied to clipboard...');
  };
  const handleToolbarClick = (args) => {
    // The 'args' object contains information about the clicked item
    if (args.item.iconCss.includes('-like')) {
      // Add your custom logic here (e.g., send feedback to a server)
      console.log('thank you for your feedback');
    } else if (args.item.iconCss.includes('-dislike')) {
      console.log('thank you for your feedback');
    } else if (args.item.iconCss.includes('-copy')) {
      handleCopy(airesponse);
    }
  };

  const responseToolbarSettings = {
    items: [
      { type: 'Button',
        iconCss: 'e-icons e-copy',
      },
      { type: 'Button',
        iconCss: 'e-icons e-assist-like',
      },
      { type: 'Button',
        iconCss: 'e-icons e-assist-dislike',
      },
    ],
    itemClicked: handleToolbarClick,
  };

  return (
    <div
      className="nav-item absolute right-1 top-26 bg-white dark:bg-[#42464D] p-8 rounded-lg w-96"
      id="faq"
      style={{
        height: '600px', /* A fixed height is often required for overflow to work correctly */
        width: '600px',
        overflowY: 'scroll', /* Always shows the scrollbar */
      }}
    >
      <div className="flex justify-between items-center">
        <p className="font-semibold text-lg dark:text-gray-200 ml-20">{dt}</p>
      </div>
      <div className="zackat-divalh">
        {/* Specifies the tag to render the AI AssistView component */}
        <div id="containerToolbar">
          <AIAssistViewComponent
            id="aiAssistViewZ"
            promptSuggestions={promptSuggestions}
            promptRequest={onPromptRequest}
            ref={assistInstance}
            bannerTemplate={bannerTemplate}
            responseToolbarSettings={responseToolbarSettings}
          />
        </div>
      </div>
    </div>
  );
};

export default UserFAQ;
